import { useTranslation } from "react-i18next";
import { Folder } from "lucide-react";
import { FileCodeTag } from "../FileCodeTag";
import { FolderNameInput } from "./FolderNameInput";
import type { FolderPaneHeaderProps } from "./types";

export const FolderPaneHeader = ({
  folder,
  planCount,
  isDisabled,
  onRename,
}: FolderPaneHeaderProps) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-shrink-0 items-center gap-2.5 border-b border-gray-200 px-4 py-3">
      <span className="flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-lg border border-blue-300 bg-blue-50 text-blue-700">
        <Folder size={16} />
      </span>
      <span className="flex min-w-0 flex-1 items-center gap-2 text-base">
        <FolderNameInput
          folderKey={folder.key}
          name={folder.name}
          isDisabled={isDisabled}
          onRename={onRename}
        />
        {folder.fileCode !== null && <FileCodeTag fileCode={folder.fileCode} />}
      </span>
      <span className="flex-shrink-0 whitespace-nowrap rounded bg-gray-100 px-2 py-0.5 text-xs font-medium text-gray-600">
        {t("smartSurveyor.folders.suggestion.planCount", { count: planCount })}
      </span>
    </div>
  );
};
